import { createFileRoute, redirect } from '@tanstack/react-router'
import { PlatformLoginPage } from '../../features/platform/login-page'
import { platformLoginSearchSchema } from '../../features/platform/search'
import {
  platformSessionQueryOptions,
  platformSignInMethodsQueryOptions,
  safePlatformRedirect,
} from '../../features/platform/session'

export const Route = createFileRoute('/platform/login')({
  validateSearch: platformLoginSearchSchema,
  beforeLoad: async ({ context, search }) => {
    // Already signed in to the console: skip the form. Always ask the server — a cached session may
    // be the very one that just expired and sent the operator here.
    const session = await context.queryClient
      .fetchQuery({ ...platformSessionQueryOptions, staleTime: 0 })
      .catch(() => null)
    if (session) throw redirect({ href: safePlatformRedirect(search.redirect), replace: true })
  },
  // Password, cloudTech Hub or both (ADR-042). Null when the server cannot say: the page then shows the
  // password form alone, as before the Hub.
  loader: ({ context }) =>
    context.queryClient.fetchQuery(platformSignInMethodsQueryOptions).catch(() => null),
  component: PlatformLoginPage,
})
